import { useTranslation } from 'react-i18next';
import { PasswordRules } from '../constants';

type RulesId =
  | PasswordRules.validLength
  | PasswordRules.includeUppercase
  | PasswordRules.includeLowercase;

interface Rule {
  id: RulesId;
  name: string;
}

/**
 * A custom hook that returns an array of password rules with their names
 * translated to the current language using i18next's `useTranslation` hook.
 */
export const usePasswordRules = () => {
  const { t } = useTranslation();

  // Define an array of password rules, with their names translated.
  const passwordRules: Rule[] = [
    {
      id: PasswordRules.validLength,
      name: t('auth.create_password.validation.rule1'),
    },
    {
      id: PasswordRules.includeUppercase,
      name: t('auth.create_password.validation.rule2'),
    },
    {
      id: PasswordRules.includeLowercase,
      name: t('auth.create_password.validation.rule3'),
    },
  ];

  return passwordRules;
};
